import type { Locale } from 'vue-i18n'

export const FAQ_LINK: Record<Locale, string> = {
  'zh-tw': 'https://help.myfunnow.com/hc/zh-tw',
  'zh-cn': 'https://help.myfunnow.com/hc/zh-tw',
  ja: 'https://help.myfunnow.com/hc/en-us',
  en: 'https://help.myfunnow.com/hc/en-us',
  th: 'https://help.myfunnow.com/hc/th',
}

export const FAQ_SECTION_IDS = {
  funCoin: '47081374629401-Fun-幣-優惠碼相關',
  funMiles: '47081362700441-FunMiles',
}
